import { useSelector } from "react-redux";

function IntroArea() {
  // overall preview state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  return (
    <div className="intro-area">
      <img alt={currentRequest.SKUName} src={currentRequest.DefaultRightPanelImage} />
    </div>
  );
}

export default IntroArea;
